module.exports = __webpack_public_path__ + "static/img/bg-lx.0854d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-lx.png
// module id = jj9g
// module chunks = 0